"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionItemStatus = void 0;
var common_1 = require("../../../common");
var react_intl_1 = require("react-intl");
var react_1 = __importDefault(require("react"));
var SignatureInfoModalStyles_1 = require("../SignatureInfoModalStyles");
exports.AccordionItemStatus = function (props) {
    var signatureStatus = props.signatureStatus;
    var signatureInfoClasses = SignatureInfoModalStyles_1.useSignatureInfoModalStyles({ signatureStatus: signatureStatus });
    return (react_1.default.createElement(common_1.StatusBar, { className: signatureInfoClasses.bar },
        react_1.default.createElement(react_intl_1.FormattedMessage, { id: signatureStatus })));
};
